import { gql } from "apollo-boost";

const LOGIN = gql`
  mutation login($data: String, $email: String!, $password: String!) {
    login(data: $data, email: $email, password: $password) {
      token
      analytics_data {
        user_id
        user_type
        flow
      }
      is_unverified_industry
    }
  }
`;

export default LOGIN;
